import { render, staticRenderFns } from "./LegalStatus.vue?vue&type=template&id=2a403419&"
import script from "./LegalStatus.vue?vue&type=script&lang=js&"
export * from "./LegalStatus.vue?vue&type=script&lang=js&"
import style0 from "./LegalStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports